import React from "react";

/**
 * Tooltip custom pentru breakdown-ul de necesar pe zi.
 * Afișează lista regiilor/proiectelor cu min necesar, evidențiind cu pulse
 * rândurile care diferă față de ziua anterioară.
 *
 * Folosit în Planificator.jsx peste celulele zilelor.
 */
export default function NeedBreakdownTooltip({ items, prevIso, totalP, isoDay }) {
  if (!items || items.length === 0) {
    return (
      <span className="pointer-events-none absolute left-0 top-full mt-1 z-50 hidden group-hover:block whitespace-nowrap bg-zinc-900 text-white text-[11px] rounded px-2 py-1 shadow-lg">
        Total NECESAR = 0
      </span>
    );
  }
  return (
    <span
      role="tooltip"
      className="pointer-events-none absolute left-0 top-full mt-1 z-50 hidden group-hover:block bg-zinc-900 text-white text-[11px] rounded-md shadow-xl border border-zinc-700 min-w-[280px] max-w-[420px]"
      data-testid={`need-breakdown-${isoDay}`}
    >
      <div className="px-2.5 py-1.5 border-b border-zinc-700 flex items-center justify-between gap-2">
        <span className="font-semibold">Total NECESAR = {totalP} pers</span>
        {prevIso && (
          <span className="text-[9px] uppercase tracking-wider text-amber-300">vs. {prevIso}</span>
        )}
      </div>
      <ul className="py-1 max-h-[60vh] overflow-y-auto">
        {items.map((b, idx) => {
          const isDiff = !!b.diff;
          const delta = isDiff && b.prevMin != null ? (b.min - b.prevMin) : null;
          return (
            <li
              key={`${b.key}-${idx}`}
              className={`px-2.5 py-1 flex items-start gap-2 text-[11px] leading-snug ${isDiff ? "bg-amber-500/20 text-amber-100 animate-pulse border-l-4 border-amber-400" : "text-zinc-200"}`}
            >
              <span className="flex-1 break-words">
                {b.firma && <span className="text-zinc-400">🏢 {b.firma} · </span>}
                <span className="font-medium">{b.label}</span>
              </span>
              <span className="shrink-0 tabular-nums font-bold">
                {b.min} pers
                {isDiff && (
                  <span className="ml-1.5 text-amber-200 font-semibold">
                    (era {b.prevMin}{delta != null ? ` · ${delta > 0 ? "+" : ""}${delta}` : ""}) ⚠️
                  </span>
                )}
              </span>
            </li>
          );
        })}
      </ul>
      <div className="px-2.5 py-1 border-t border-zinc-700 text-[9px] text-zinc-400">
        Rândurile evidențiate cu pulsație au minim diferit față de ziua precedentă.
      </div>
    </span>
  );
}
